import { render, staticRenderFns } from "./TabIconText.vue?vue&type=template&id=c7c544ea"
import script from "./TabIconText.vue?vue&type=script&lang=js"
export * from "./TabIconText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports